import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Breadcumb from './Breadcumb';
import ContactForm from './ContactForm';
import Map from './Map';
import { fetchMetadata } from '../utils/api';

function Main() {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const data = await fetchMetadata();
        const contactMetadata = data.find((item) => item.pageName === 'contact-us');
        if (!contactMetadata) {
          setError('Contact Us page metadata not found');
          setLoading(false);
          return;
        }
        setSeoData(contactMetadata);
        setLoading(false);
      } catch (err) {
        setError('Failed to load SEO metadata');
        setLoading(false);
      }
    };
    loadMetadata();
  }, []);

  return (
    <>
      <Helmet>
        <title>{seoData?.title || 'Contact Us | Bluelagoon Travels'}</title>
        <meta
          name='description'
          content={seoData?.description || 'Get in touch with Bluelagoon Travels.'}
        />
        <meta
          name='keywords'
          content={seoData?.keywords || 'contact, travel agency'}
        />
        <meta
          name='pageName'
          content={seoData?.pageName || 'contact-us'}
        />
      </Helmet>
      <Breadcumb />
      <ContactForm />
      <Map />
    </>
  );
}

export default Main;
